import * as yup from 'yup'

const getRequiredTranslationId = (requiredTranslationId?: string) =>
  requiredTranslationId || 'common.commonErrors.required'

export const validateRequiredString = (requiredTranslationId?: string) =>
  yup.string().required(getRequiredTranslationId(requiredTranslationId))

export const validateRequiredStringMatch = (
  regex: RegExp,
  matchTranslationId?: string
) => validateRequiredString().matches(regex, matchTranslationId)

export const validateNullableString = () => yup.string().nullable()

export const validateStringMaxLength = (maxLength: number) =>
  yup.string().max(maxLength, 'common.commonErrors.tooLong')

export const validateNumberType = (translationId?: string) =>
  yup
    .number()
    .typeError(translationId || 'common.commonErrors.invalidCharacters')

export const validateCommaNumberType = (translationId?: string) =>
  yup
    .number()
    .transform((_value, originalValue) =>
      Number(originalValue.toString().replace(/,/, '.'))
    )
    .typeError(translationId || 'common.commonErrors.invalidCharacters')

export const validateRequiredNumber = (
  typeTranslationId?: string,
  requiredTranslationId?: string
) =>
  validateNumberType(typeTranslationId).required(
    getRequiredTranslationId(requiredTranslationId)
  )

export const validateRequiredNumberWithCommas = (
  typeTranslationId?: string,
  requiredTranslationId?: string
) =>
  validateCommaNumberType(typeTranslationId).required(
    getRequiredTranslationId(requiredTranslationId)
  )

export const validatePositiveNumber = (positiveTranslationId?: string) =>
  yup
    .number()
    .positive(
      positiveTranslationId || 'common.commonErrors.valueMustBePositive'
    )

export const validateRequiredPositiveNumberWithCommas = (
  positiveTranslationId?: string,
  typeTranslationId?: string,
  requiredTranslationId?: string
) =>
  validatePositiveNumber(positiveTranslationId).concat(
    validateRequiredNumberWithCommas(typeTranslationId, requiredTranslationId)
  )

export const validateDateType = (translationId?: string) =>
  yup.date().typeError(translationId || 'common.commonErrors.invalidDate')

export const validateRequiredDate = (
  requiredTranslationId?: string,
  typeTranslationId?: string
) =>
  validateDateType(typeTranslationId).required(
    getRequiredTranslationId(requiredTranslationId)
  )

export const validateStartBeforeEndDate = <T>(
  startdateKey: keyof T,
  startBeforeEndTranslationId: string,
  requiredTranslationId?: string,
  typeTranslationId?: string
) => {
  let baseValidation
  if (requiredTranslationId) {
    baseValidation = validateRequiredDate(
      requiredTranslationId,
      typeTranslationId
    )
  } else {
    baseValidation = validateDateType(typeTranslationId)
  }

  return baseValidation.test(
    'test-start-before-end',
    startBeforeEndTranslationId,
    function (value) {
      if (!value || !this.parent[startdateKey]) return true
      return this.parent[startdateKey] <= value
    }
  )
}

export const validateNullableBoolean = () => yup.boolean().nullable()
